import { Divider, Drawer } from '@mui/material';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserNavigation } from '../navigation/user-navigation';

const logoImg = require('../../_assets/images/Logo-Standard.png');
const drawerWidth = 240;

export default function AppUserSidebar(params: { isOpen: boolean, setIsOpen: Dispatch<SetStateAction<boolean>> }) {
    let navigate = useNavigate();

    const [userNavOpen, setUserNavOpen] = useState(false);

    return (
        <Drawer
            sx={{
                "& .MuiPaper-root": {
                    width: 240
                }
            }}
            // onClose={() => { setIsOpen(!isOpen) }}
            variant="persistent"
            open={params.isOpen}
            id={"sidebarNavDrawer"}
            anchor="left">

            <div>
                <img style={{
                    width: "180px",
                    height: "105px",
                    marginTop: "10px",
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: "10px"
                }} src={logoImg} alt={"test"}></img>
            </div>

            <Divider />

            <UserNavigation onSelect={() => { params.setIsOpen(false) }} />
        </Drawer>
    );
}